import { render, staticRenderFns } from "./PowerGenerationInterfaceRecord.vue?vue&type=template&id=4a056cd4&scoped=true&"
import script from "./PowerGenerationInterfaceRecord.vue?vue&type=script&lang=js&"
export * from "./PowerGenerationInterfaceRecord.vue?vue&type=script&lang=js&"
import style0 from "./PowerGenerationInterfaceRecord.vue?vue&type=style&index=0&id=4a056cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a056cd4",
  null
  
)

export default component.exports